import "./NavLeft.scss";
import { Link } from "react-router-dom";

const NavLeft = () => {
  return (
    <div className="nav-left">
      <div className="nav-left__upper">
        <Link to="/staples" className="nav-right__link">
          STAPLES
        </Link>
      </div>
      <div className="nav-left__lower">
        <Link to="/gallery" className="nav-right__link">
          GALLERY
        </Link>
      </div>
    </div>
  );
};

export default NavLeft;
